import React, { useState, useEffect, Fragment } from "react";
import dayjs from "dayjs";
import { GET, POST } from "../../Utils/api";
import Input from "../../Resources/Forms/Input";
import Button from "../../Resources/Forms/Button";
import Radio from "../../Resources/Forms/Radio";
import OutletPhoto from "./OutletPhoto";
import "../../Styles/Pages/firsttimeorder.scss";
import { asset_url } from "../../app-config";
import UpdateCustomerLocation from "../Tools/UpdateCustomerLocation";
import { _getLocationDistances } from "../../Utils/helpers";
import Loading from "../../Loaders/Loading";

const FirstTimeOrder = props => {
	const [activeImageIndex, setActiveImageIndex] = useState(0);
	const [showLoading, setShowLoading] = useState(true);
	const [formStep, setFormStep] = useState(1);
	const [showLoader, setShowLoader] = useState(false);
	const [storeAddress, setStoreAddress] = useState("");
	const [retailStoreData, setRetailStoreData] = useState({});
	const [isCustomerLocation, setCustomerLocation] = useState("YES");
	const [isConfirmCustomerLocation, setConfirmCustomerLocation] = useState(
		"YES",
	);
	const [storeImages, setStoreImages] = useState([]);
	const [updateCustomerLocation, setupdateCustomerLocation] = useState(false);
	const [longitude, setLongitude] = useState(
		Number(props.context.userLocation.longitude || "0"),
	);
	const [latitude, setLatitude] = useState(
		Number(props.context.userLocation.latitude || "0"),
	);
	const [contactOrgType, setContactOrgType] = useState([]);
	const [orgTypeValue, setOrgTypeValue] = useState("");
	const [initialOrgTypeValue, setInitialOrgTypeValue] = useState("");

	useEffect(() => {
		GetRetailStoreVerificationData();
		getContactOrgType();
		GetBusinessOrganizationType();
	}, []);
	const getAddress = async () => {
		setConfirmCustomerLocation("NO");
		if (!props.context.userLocation.longitude) {
			navigator.geolocation.watchPosition(
				position => {
					window.location.reload();
				},
				error => {
					props.context.showAlert("Please enable GPS access", "error");
				},
			);
		}
	};
	const GetRetailStoreVerificationData = async () => {
		const result = await GET(
			`Store/GetRetailStoreVerificationData?Customerid=${props.orderDetails.Customerid}&orderId=${props.orderDetails.Orderid}`,
		);
		if (!result.error && result.OutletDetails) {
			setShowLoading(false);
			setRetailStoreData(result.OutletDetails[0]);
			const address = await props.context.getUserAddress("Add Customer");
			setStoreAddress(address || result.OutletDetails[0].storeAddress);
			setStoreImages(result.OutletDetails[0].storeImages || []);
			if (result.OutletDetails[0].Step < 4)
				setFormStep(result.OutletDetails[0].Step + 1);
			else {
				props.setFirstTimeOrder(0);
			}
		} else {
			setShowLoading(false);
		}
	};
	const submitSteps = flag => {
		switch (formStep) {
			case 1:
				initialOrgTypeValue !== orgTypeValue && updateContactOrgType();
				if (isCustomerLocation === "NO") {
					// we will call api for reject or cancel orders via driver
					//props.setFirstTimeOrder(1); stop now cancel RTO
					flag === 1 && EditRetailStoreVerificationData(1);
				} else {
					//Customer Location
					flag === 1 && EditRetailStoreVerificationData(1);
				}
				break;
			case 2:
				//confirm Customer Location
				if (flag === 1) {
					if (
						isConfirmCustomerLocation === "NO" &&
						!props.context.userLocation.longitude
					) {
						navigator.geolocation.watchPosition(
							position => {
								window.location.reload();
							},
							error => {
								props.context.showAlert("Please enable GPS access", "error");
							},
						);
					} else {
						EditRetailStoreVerificationData(2);
					}
				} else {
					setFormStep(1);
				}
				break;
			case 3:
				//confirm custoomer image
				if (flag === 1) {
					const answerno = storeImages.filter(f => f.answer).length;
					if (storeImages.length === answerno) {
						EditRetailStoreVerificationData(3);
					} else {
						props.context.showAlert("Please confirm all images", "error");
					}
				} else {
					setFormStep(2);
				}
				break;
			case 4:
				//Uploaded Images
				if (flag === 1) {
					const addedImages = props.imageTagData
						? props.imageTagData.addedImages || []
						: [];
					if (addedImages.length < 3)
						props.context.showAlert(
							"Please take minimum of 3 pictures",
							"error",
						);
					else EditRetailStoreVerificationData(4);
				} else {
					flag === 0 ? setFormStep(3) : props.setFirstTimeOrder(0);
				}
				break;
			default:
				setFormStep(6);
				break;
		}
	};
	const getContactOrgType = async () => {
		const result = await GET(
			`OrderManagement/getContactOrgType?customerId=${props.orderDetails.Customerid}`,
		);
		if (!result.error && result.length > 0) {
			setOrgTypeValue(result[0]);
			setInitialOrgTypeValue(result[0]);
		} else {
			setOrgTypeValue("");
			setInitialOrgTypeValue("");
		}
	};
	const GetBusinessOrganizationType = async () => {
		const result = await GET(
			`addressbook/GetBusinessOrganizationType?LoggedInUserId=${props.context.userId}&isOutletType=0`,
		);
		if (!result.error && result.Type && result.Type.length > 0) {
			setContactOrgType(result.Type);
		} else {
			setContactOrgType([]);
		}
	};
	const updateContactOrgType = async () => {
		if (!orgTypeValue) {
			props.context.showAlert(
				"Please choose the type of organization",
				"error",
			);
		} else if (orgTypeValue) {
			let data = {
				customerId: props.orderDetails.Customerid,
				organizationType: orgTypeValue,
			};
			await POST("OrderManagement/updateContactOrgType", data);
		}
	};
	const assignStoreImagesAnswer = ans => {
		let imgList = [];
		storeImages.forEach((img, index) => {
			if (activeImageIndex === index) {
				img.answer = ans;
			}
			imgList.push(img);
		});
		setStoreImages(imgList);
	};
	const EditRetailStoreVerificationData = async step => {
		try {
			setShowLoader(true);
			let RetailData = new FormData();
			RetailData.set("step", step);
			RetailData.set("flag", 1);
			RetailData.set("Customerid", props.orderDetails.Customerid);
			RetailData.set("OrderID", props.orderDetails.Orderid);
			step === 1 && RetailData.set("storeDescription", isCustomerLocation);
			if (step === 2) {
				RetailData.set(
					"location",
					isConfirmCustomerLocation === "NO"
						? storeAddress
						: isConfirmCustomerLocation,
				);
				RetailData.set("latitude", latitude);
				RetailData.set("longitude", longitude);
			}
			if (step === 3) {
				const ConfirmRetailImagesDetails = [];
				storeImages.forEach(el => {
					ConfirmRetailImagesDetails.push({
						ImageId: el.customerImageId,
						isConfirmed: el.answer,
					});
				});
				ConfirmRetailImagesDetails.length > 0 &&
					RetailData.set(
						"ConfirmRetailImagesDetails",
						JSON.stringify(ConfirmRetailImagesDetails),
					);
			}
			if (step === 4) {
				const addedImages = props.imageTagData
					? props.imageTagData.addedImages || []
					: [];
				addedImages.forEach((image, i) => {
					RetailData.set(`${image.tagId}`, image.file);
				});
			}
			const result = await POST(
				"store/EditRetailStoreVerificationData",
				RetailData,
			);
			if (!result.error) {
				setShowLoader(false);
				step === 4 ? props.setFirstTimeOrder(0) : setFormStep(step + 1);
			} else {
				setShowLoader(false);
				props.context.showAlert("An error occured. Please try again", "error");
			}
		} catch (error) {
			setShowLoader(false);
		}
	};
	const slideImage = type => {
		if (type === 1) {
			if (activeImageIndex === 0) {
				setActiveImageIndex(storeImages.length - 1);
			} else {
				setActiveImageIndex(activeImageIndex - 1);
			}
		} else {
			if (activeImageIndex + 1 === storeImages.length) {
				setActiveImageIndex(0);
			} else {
				setActiveImageIndex(activeImageIndex + 1);
			}
		}
	};
	return (
		<Fragment>
			{showLoading ? (
				<Loading size={"4px"} margin={"80px auto 150px"} />
			) : (
				<div className="customer__location">
					<div className="customer__location__header">
						<div className="customer__location__header__flex__between">
							<div className="customer__location__header__name">
								{props.orderDetails.OrganizationName ||
									props.orderDetails.CustomerName ||
									"Guest"}
							</div>
							<div className="customer__location__header__first__order">
								First Order
							</div>
						</div>
						<div className="customer__location__header__order__id">
							Order #{props.orderDetails.Orderid}
						</div>
						<div className="customer__location__header__date">
							Order date:{" "}
							{dayjs(props.orderDetails.Createddate).format(
								`MMM D, YYYY.${window.screen.width > 350 ? "h:mm a" : ""}`,
							)}{" "}
						</div>
					</div>

					<div className="customer__location__body">
						<div>
							{formStep === 1 ? (
								<>
									<div className="customer__location__body__box">
										<div className="customer__location__body__box__label">
											Are you at the Customer Location?
										</div>
										<Radio
											label={"Yes"}
											checked={isCustomerLocation === "YES" ? true : false}
											onChange={() => null}
											onClick={() => setCustomerLocation("YES")}
											value={isCustomerLocation}
											id={1}
										/>

										<Radio
											label={"No"}
											checked={isCustomerLocation === "NO" ? true : false}
											onChange={() => null}
											onClick={() => setCustomerLocation("NO")}
											value={isCustomerLocation}
											id={2}
										/>
									</div>
									{contactOrgType && contactOrgType.length > 0 && (
										<div
											className="customer__location__body__box"
											style={{ marginTop: "20px" }}
										>
											<div className="customer__location__body__box__label">
												What type of organization is it?
											</div>
											{contactOrgType.map((orgType, i) => {
												return (
													<Radio
														label={orgType.OrganizationType}
														checked={
															orgTypeValue === orgType.OrganizationType
																? true
																: false
														}
														onChange={() => null}
														onClick={() =>
															setOrgTypeValue(orgType.OrganizationType)
														}
														value={orgTypeValue}
														id={`orgType_${i}`}
													/>
												);
											})}
										</div>
									)}
								</>
							) : formStep === 2 ? (
								<div className="customer__location__body__box">
									<div className="customer__location__body__box__distance">
										{`You are ${
											_getLocationDistances(
												retailStoreData.storeLatitude || latitude,
												retailStoreData.storeLongitude || longitude,
												latitude,
												longitude,
											) || "0 m"
										} from the registered location`}
									</div>
									<div className="customer__location__body__box__label">
										Kindly confirm customer location as
									</div>
									<div className="customer__location__body__box__address__location">
										<span>
											<img
												src="Images/location.png"
												alt="location"
												width="10"
												height="12"
											/>
										</span>

										<span className="customer__location__body__box__address">
											{retailStoreData.storeAddress}
										</span>
									</div>
									<Radio
										label={"Yes"}
										checked={isConfirmCustomerLocation === "YES" ? true : false}
										onChange={() => null}
										onClick={() => setConfirmCustomerLocation("YES")}
										value={isConfirmCustomerLocation}
										id={1}
									/>

									<Radio
										label={"No"}
										checked={isConfirmCustomerLocation === "NO" ? true : false}
										onChange={() => null}
										onClick={() => {
											getAddress();
										}}
										value={isConfirmCustomerLocation}
										id={2}
									/>
									{isConfirmCustomerLocation === "NO" && (
										<div style={{ position: "relative" }}>
											<span className="customer__location__body__box__location__img">
												<img
													src="Images/location.png"
													width="16"
													height="20"
													alt="location"
												/>
											</span>
											<div
												className={`default-contact-input ${
													1 ? "default-contact-input-address" : ""
												}`}
											>
												<Input
													label={"Customer Location"}
													value={storeAddress}
													disabled={true}
													withIcon={"30px"}
												/>
												{1 && (
													<span onClick={() => setupdateCustomerLocation(true)}>
														<img src="Images/googlemaps.svg" alt="" />
														Update
													</span>
												)}
											</div>
										</div>
									)}
								</div>
							) : formStep === 3 ? (
								<div className="customer__location__body__box">
									<div className="customer__location__body__box__confirm">
										Please confirm that the store images below is similar to the
										store you are delivering to
									</div>
									<div className="customer__location__body__box__confirm__label">
										Store Images
									</div>
									{storeImages.length > 0 && (
										<>
											<div className="first-time-order-imagepreview-carousel">
												<div className="first-time-order-imagepreview">
													<img
														src={`${asset_url}${storeImages[activeImageIndex].image}`}
														alt=""
													/>
													{storeImages[activeImageIndex].tagName && (
														<p>{storeImages[activeImageIndex].tagName}</p>
													)}
												</div>
												{storeImages.length > 1 && (
													<React.Fragment>
														<span
															onClick={() => slideImage(1)}
															className="carousel-nav nav-left"
														>
															<img src="Images/back-arrow.svg" alt="" />
														</span>
														<span
															onClick={() => slideImage(2)}
															className="carousel-nav nav-right"
														>
															<img src="Images/back-arrow.svg" alt="" />
														</span>
													</React.Fragment>
												)}
											</div>
											<div className="customer__location__body__box__confirm__radio">
												<Radio
													label={"Yes"}
													checked={
														storeImages[activeImageIndex].answer === "YES"
															? true
															: false
													}
													onChange={() => null}
													onClick={() => assignStoreImagesAnswer("YES")}
													value={"YES"}
													id={1}
												/>
												<Radio
													label={"No"}
													checked={
														storeImages[activeImageIndex].answer === "NO"
															? true
															: false
													}
													onChange={() => null}
													onClick={() => assignStoreImagesAnswer("NO")}
													value={"NO"}
													id={2}
												/>
											</div>
										</>
									)}
								</div>
							) : (
								formStep === 4 && (
									<div className="customer__location__body__box">
										<div className="customer__location__body__box__upload__photo">
											Please take minimum of 3 pictures of the outlet (Outside
											far, Outside near, Inside)
										</div>

										<div className="customer__location__body__box__confirm__upload__new">
											Upload new collected Images
										</div>
										<OutletPhoto
											setShowImageTagging={props.setShowImageTagging}
											imageTagData={props.imageTagData}
											isDriver={true}
										/>
									</div>
								)
							)}
						</div>
					</div>
					<div className="modal-submit">
						{formStep > 1 && (
							<Button
								type={"default"}
								text={"Back"}
								onClick={() => submitSteps(0)}
							/>
						)}
						<Button
							type={"primary"}
							text={"Next"}
							onClick={() => submitSteps(1)}
							loading={showLoader}
						/>
					</div>
					{updateCustomerLocation && (
						<UpdateCustomerLocation
							close={() => setupdateCustomerLocation(false)}
							longitude={Number(props.context.userLocation.longitude || "0")}
							latitude={Number(props.context.userLocation.latitude || "0")}
							address={storeAddress}
							initialLocation={props.context.userLocation}
							allowUpdate={true}
							updateLocation={(longitude, latitude, address) => {
								setStoreAddress(address);
								setupdateCustomerLocation(false);
								setLatitude(latitude);
								setLongitude(longitude);
							}}
						/>
					)}
				</div>
			)}
		</Fragment>
	);
};

export default FirstTimeOrder;
